



















import { defineComponent, ref } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import BaseIcon from "@/components/BaseIcon";
import { colorList } from "../../../../../config";

export default defineComponent({
  name: "ColorPicker",
  components: { BaseIcon, Swiper, SwiperSlide },
  setup(_, { emit }) {
    const swiperOptions = ref<SwiperOptions>({
      allowTouchMove: true,
      freeMode: false,
      grabCursor: true,
      loop: true,
      slidesPerView: 4,
      slidesPerGroup: 4,
      direction: "vertical",
      breakpoints: {
        600: {
          allowTouchMove: true,
          freeMode: false,
          grabCursor: true,
          slidesPerView: 8,
          slidesPerGroup: 8,
          slidesPerColumn: 1,
          direction: "horizontal",
          pagination: {
            el: ".swiper-pagination",
            bulletElement: "div",
            bulletClass: "swiper-pagination__bullet",
            bulletActiveClass: "swiper-pagination__bullet __active",
            dynamicBullets: true,
            clickable: true,
          },
          navigation: {
            prevEl: ".color-picker__slider-prev",
            nextEl: ".color-picker__slider-next",
          },
        },
      },
    });
    const swiperComponentRef = ref<any>(null);

    const handleNavigate = () => {
      emit("click:navigation");
    };

    const onSelectColor = (index: number) => {
      emit("changeColor", index);
    };

    return {
      colorList,
      swiperOptions,
      swiperComponentRef,
      handleNavigate,
      onSelectColor,
    };
  },
});
